<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 mb-3 mb-md-0">
          <div class="footer__header">
            <router-link to="/home" class="footer__logo"></router-link>
            <div class="d-none d-sm-flex">
              <drop-down v-cloak :text="selectedRegion ? selectedRegion : ''" class="--country mr-3" @showDrop="showDrop">
                <template v-slot:dropdown__wrapper>
                  <div class="dropdown__wrapper">
                    <input type="text" class="search-string"/>
                    <span class="dropdown__current">{{ $store.state.language }}</span>
                  </div>
                </template>
                <!-- 使用 "header" 插槽 -->
                <template v-slot:drop-down-item>
                  <drop-down-item  class="dropdown__list" style="display: none;" v-show="showDropF">
                    <template v-slot:li>
                      <li v-for="(region, code) in $t('i18n.regions')" :key="code" @click="changeRegion(region)">
                        <span>{{ region }}</span>
                      </li>
                    </template>
                  </drop-down-item>
                </template>
              </drop-down>
            </div>
            <div class="footer__scroll-up" id="scroll-to-top" @click="goTop">
              <div class="footer__scroll-up-text">{{ $t("i18n.backHome") }}</div>
              <span class="footer__scroll-up-icon"></span>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-2 mt-md-5" v-for="(item, index) of $t('i18n.footerList')" :key="index">
          <div class="footer__content">
            <span class="footer__content-title" @click="showC(item)">{{ item.name }}</span>
            <ul :class=" {'show-class': item.show} ">
              <li v-for="(child, cIndex) of item.children" :key="cIndex">
                <router-link :to="child.path" >{{ child.name }}</router-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-1 mt-md-5">
          <div class="footer__copy">
            <p class="footer__copy-text">{{ $t("i18n.companyAbout") }}
              <a href="https://beian.miit.gov.cn/ " target="_blank">苏ICP备2022046328号-1</a>
            </p>
            
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import "../assets/css/main.css"
import DropDown from "./DropDown";
import DropDownItem from "./DropDownItem";
export default {
  name: "Footer",
  components: {DropDownItem, DropDown},
  data() {
    return {
      currentLang: 'zh',
      selectedRegion: "中文",
      showDropF: false,
      style1: "{display: block;}"
    }
  },

  mounted() {
    // this.currentIndex = sessionStorage.getItem("pagePath") || 1;
    this.currentLang = sessionStorage.getItem("language") || 'zh';
    if (this.currentLang == 'zh') {
      this.$store.commit('saveLanguage', '中文')
      this.$i18n.locale = "zh";
    } else {
      this.$i18n.locale = "en";
      this.$store.commit('saveLanguage', 'English')
    }
  },
  methods: {
    showDrop() {
      this.showDropF = !this.showDropF;
    },
    changeRegion(region) {
      sessionStorage.setItem("language", region === "中文" ? 'zh' : 'en');
      this.$store.commit('saveLanguage', region)
      this.$i18n.locale = region === "中文" ? 'zh' : 'en';
      this.$router.go(0);
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
    },
    showC(item) {
      item.show = !item.show
    },
  },
}
</script>

<style scoped>
.footer {
  background: #fafafa;
  padding: 10rem 0;
  border-top: .1rem solid #e6e6e6;
}
.footer__header:not(.--without-links) {
  padding-bottom: 5rem;
  border-bottom: 0.1rem solid #e6e6e6;
}
.footer__header {
  display: flex;
  align-items: center;
}
.footer__logo {
  width: 10.6rem;
  min-width: 10.6rem;
  height: 3.5rem;
  margin-right: 5rem;
  background: url(../assets/imgs/logoFooter.png) no-repeat 50%;
  background-size: 100% auto;
}
.d-none {
  display: none !important;
}
.footer__scroll-up {
   display: flex;
   margin-left: auto;
   align-items: center;
   font-size: 1.6rem;
   color: #7f7f7f;
   letter-spacing: 0;
   cursor: pointer;
   transition: all .2s ease-in-out;
 }
.footer__scroll-up-icon {
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
  margin-left: 1.5rem;
  position: relative;
  transition: all .2s ease-in-out;
}
.footer__scroll-up-icon:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: black;
  -webkit-mask: url(../assets/imgs/arrow-up.png) no-repeat center;
  mask: url(../assets/imgs/arrow-up.png) no-repeat center;
  transition: all .2s ease-in-out;
}
.footer__content-title {
  font-weight: 600;
  font-size: 1.6rem;
  color: #000;
  letter-spacing: .035rem;
  text-transform: uppercase;
  line-height: 1.7rem;
  margin-bottom: 1rem;
  display: block;
}
ol, ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.footer__content ul li:hover a {
  color: #990099;
}

.footer__content ul li a {
  font-size: 1.4rem;
  color: #7f7f7f;
  letter-spacing: 0;
  line-height: 2rem;
  padding: .5rem 0;
  min-height: 3rem;
  display: flex;
  align-items: center;
  transition: .4s;
}
a {
  text-decoration: none;
  transition-property: all;
  transition-duration: .3s;
}
.footer__copy {
  padding-top: 5rem;
  border-top: 0.1rem solid #e6e6e6;
  align-items: center;
  text-align: center;
}
.footer__copy-text {
  /* font-size: 1.6rem; */
  font-size: 1.3rem;
  color: #000;
  letter-spacing: 0;
  line-height: 3rem;
}

.dropdown .dropdown__wrapper:before {
  background: #80ba27;
}
.dropdown .dropdown__wrapper:before {
  content: "";
  width: 1.6rem;
  height: 1.6rem;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -.8rem;
  background: #ccc;
  -webkit-mask: url(../assets/imgs/world.svg) no-repeat center;
  mask: url(../assets/imgs/world.svg) no-repeat center;
  transition: all .2s ease-in-out;
}
.dropdown .dropdown__wrapper:after, .dropdown.--visible.--text .dropdown__wrapper:after {
  right: 0;
}
.dropdown .dropdown__wrapper:after {
  background: lightgray;
}
.dropdown__wrapper:after {
  content: "";
  width: .8rem;
  height: .6rem;
  -webkit-mask: url(../assets/imgs/downArrow.png) no-repeat center;
  mask: url(../assets/imgs/downArrow.png) no-repeat center;
  position: absolute;
  right: 2rem;
  top: 50%;
  margin-top: -.3rem;
  transition-property: background;
  transition-duration: .3s;
}

.footer__scroll-up-text:hover {
  color: #990099;
}
@media (min-width: 768px) {
  .d-sm-flex {
    display: flex !important;
  }
}
@media (max-width: 1023.9px) {
  .footer__copy-text {
    text-align: center;
    margin-bottom: 2rem;
  }
  .show-class {
    display: block !important;
  }
  .footer__content ul {
    display: none;
    margin-bottom: 2rem;
  }
  .footer__content-title:after {
    content: "";
    width: 1rem;
    height: 1rem;
    background: url(../assets/imgs/select-arrow.png) no-repeat 50%;
    position: absolute;
    right: 0;
    margin-top: -.3rem;
    margin-right: 1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue